import { render, staticRenderFns } from "./phoneVerifyCodeInput.vue?vue&type=template&id=2c4c487d&scoped=true"
import script from "./phoneVerifyCodeInput.vue?vue&type=script&lang=js"
export * from "./phoneVerifyCodeInput.vue?vue&type=script&lang=js"
import style0 from "./phoneVerifyCodeInput.vue?vue&type=style&index=0&id=2c4c487d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c487d",
  null
  
)

export default component.exports